/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProgramOption
 */
export interface ProgramOption {
    /**
     * 
     * @type {number}
     * @memberof ProgramOption
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramOption
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramOption
     */
    nameJa: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramOption
     */
    displayOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramOption
     */
    isOther: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramOption
     */
    descriptionForApplicant?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramOption
     */
    descriptionForApplicantEn?: string;
    /**
     * 
     * @type {Option}
     * @memberof ProgramOption
     */
    programType: Option;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramOption
     */
    readonly hidden: boolean;
}

export function ProgramOptionFromJSON(json: any): ProgramOption {
    return ProgramOptionFromJSONTyped(json, false);
}

export function ProgramOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'displayOrder': !exists(json, 'displayOrder') ? undefined : json['displayOrder'],
        'isOther': json['isOther'],
        'descriptionForApplicant': !exists(json, 'descriptionForApplicant') ? undefined : json['descriptionForApplicant'],
        'descriptionForApplicantEn': !exists(json, 'descriptionForApplicantEn') ? undefined : json['descriptionForApplicantEn'],
        'programType': OptionFromJSON(json['programType']),
        'hidden': json['hidden'],
    };
}

export function ProgramOptionToJSON(value?: ProgramOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'nameJa': value.nameJa,
        'displayOrder': value.displayOrder,
        'isOther': value.isOther,
        'descriptionForApplicant': value.descriptionForApplicant,
        'descriptionForApplicantEn': value.descriptionForApplicantEn,
        'programType': OptionToJSON(value.programType),
    };
}


